import React from 'react';
import { ChevronDown } from 'lucide-react';

const Field = ({ id, label, children }) => <div className="plinko-setting-field">
  <label htmlFor={id} className="keno-label" data-testid={`${id}-label`}>{label}</label>
  <div className="plinko-select-wrap">{children}<ChevronDown className="plinko-select-chevron" size={17} aria-hidden="true" /></div>
</div>;

export const PlinkoSettings = ({ game, locked }) => <div className="plinko-settings" data-testid="plinko-settings">
  <Field id="plinko-risk" label="Difficulty">
    <select id="plinko-risk" data-testid="plinko-risk-select" className="plinko-select" value={game.plinko.risk} disabled={locked} onChange={(event) => game.plinko.setRisk(event.target.value)}>{['low', 'medium', 'high', 'expert'].map((risk) => <option key={risk} value={risk} data-testid={`plinko-risk-${risk}`}>{risk[0].toUpperCase() + risk.slice(1)}</option>)}</select>
  </Field>
  <Field id="plinko-rows" label="Rows">
    <select id="plinko-rows" data-testid="plinko-rows-select" className="plinko-select" value={game.plinko.rows} disabled={locked} onChange={(event) => game.plinko.setRows(Number(event.target.value))}>{Array.from({ length: 9 }, (_, index) => index + 8).map((rows) => <option key={rows} value={rows} data-testid={`plinko-rows-${rows}`}>{rows}</option>)}</select>
  </Field>
</div>;
